// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1MymX","col":"styles_col__3VHPp"};